import { useState } from "react";

const Credit = () => {
  const [creditState, setCreditState] = useState(false);

  const handleClick = () => {
    if (creditState) {
      setCreditState(false)
    } else {
      setCreditState(true)
    }
  }

  return (
    <>
      <button onClick={handleClick} className='Start-Link Credit'>Audio Credits</button>
      {creditState ? (
        <div className="Popup">
          <p>
            The Say That Again! web game was created with the following audio, everything else was produced in house:
            <br></br>
            <br></br>
            Library Noises by LittleCloudCinema -- https://freesound.org/s/253947/ -- License: Creative Commons 0
            <br></br>
            Forest Background Noise by f-r-a-g-i-l-e -- https://freesound.org/s/506268/ -- License: Creative Commons 0
            <br></br>
            Clock_Tick_Tock_Loop.wav by michael_grinnell -- https://freesound.org/s/464402/ -- License: Creative Commons 0
            <br></br>
            boedie_alfa_romeo_MiTo_honking_car_horn.wav by boedie -- https://freesound.org/s/457425/ -- License: Creative Commons 0
            <br></br>
            Dog barking in forest when jogger passend by by AtoMediaDesign -- https://freesound.org/s/649021/ -- License: Attribution 4.0
            <br></br>
            people market NL 200520_0177.wav by klankbeeld -- https://freesound.org/s/622893/ -- License: Attribution 4.0
            <br></br>
            STE-040 italian police siren.flac by tim.kahn -- https://freesound.org/s/28426/ -- License: Attribution 4.0
            <br></br>
            <br></br>
            Checkout Yiliyapinya at : https://yiliyapinya.org.au/
          </p>
          <button onClick={handleClick}>Close</button>
        </div>
      ) : (<></>)}
    </>
  )
};

export default Credit;
